import { InjectConfig } from "@config/InjectConfig";
import { ServiceIdentifier } from "imagica-corekit/dist/base/cutil/ServiceIdentifier";

export function getIt<T>(serviceIdentifier: ServiceIdentifier<T>): T {
  return InjectConfig.get<T>(serviceIdentifier);
}
